//===--- Main Carousel
import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';
import Accordion from 'react-bootstrap/Accordion';
//===--- Mini Carousel
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
//===--- Rewards
import Button from 'react-bootstrap/Button';
//===--- Icons
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { IoMdArrowDropdown } from "react-icons/io";
import { MdLocalOffer, MdShoppingCart } from "react-icons/md";
import { BsFillAwardFill } from "react-icons/bs";
//===--- Data
import ftMenuItems from './data/ftMenuItems';
import MenuItems from './data/menuItems';
import RewardsItems from './data/rewardsItems';
import GiftCardItems from './data/giftCardItems';

export default function Home(props) {
  function carouselScroll(bool, classVar) {
    const carouselContainer = document.querySelector(`.${classVar} .mini-carousel-items`);
    const cards = document.querySelector(`.${classVar} .item`);
  
    if (bool) {
      if (carouselContainer.scrollLeft < carouselContainer.scrollWidth - carouselContainer.offsetWidth) {
        carouselContainer.scrollTo({
          left: carouselContainer.scrollLeft + cards.offsetWidth,
          behavior: 'smooth'
        });
      }
    } else {
      if (carouselContainer.scrollLeft > 0) {
        carouselContainer.scrollTo({
          left: carouselContainer.scrollLeft - cards.offsetWidth,
          behavior: 'smooth'
        });
      }
    }
  }
  function openAccord(key) {
    let iconBtn = document.querySelector(`.item-${key} .ico-btn`);
    let accordBtn = document.querySelector(`.item-${key}{key} .accordion-button`);
    let accord = document.querySelector(`.item-${key}`);

    if (accordBtn.classList.contains('collapsed')) {
      accord.style.backdropFilter = 'blur(10px)';
      iconBtn.classList.add('active');
    } else {
      accord.style.backdropFilter = 'blur(0px)';
      iconBtn.classList.remove('active');
    }
    console.log(key)
  }
  const ftMenu = ftMenuItems.map( ({img, title, desc, key, calories}) => {
    return(
      <Carousel.Item>
        <div className='bg-img'><Image alt={title} src={img} fluid/></div>
        <Carousel.Caption>
          {props.screenSize ? <>
            <h2>{title}</h2>
            {false && <h6 className="mb-2 text-muted">{calories}</h6>}
            <p>{desc}</p>
          </> : <>
          <Accordion defaultActiveKey={['0']} alwaysOpen>
            <Accordion.Item eventKey="1" className={`rounded border-0 item-${key}`}>
              <Accordion.Header  onClick={()=>{openAccord(key)}}>
                <h2>{title}<IoMdArrowDropdown className='ico-btn'/></h2>
                {false && <h6 className="mb-2 text-muted">{calories}</h6>}
              </Accordion.Header>
              <Accordion.Body>{desc}</Accordion.Body>
            </Accordion.Item>
          </ Accordion>
          </>}
        </Carousel.Caption>
      </Carousel.Item>
    )
  })
  const FullMenu = MenuItems.flatMap(category => Object.values(category).flat());
  const Menu = FullMenu.map( ({img, title, calories, key}) => {
    return (
      <Card style={{ width: '14rem' }} className='border-0 item'>
        <a href={`#/menu/product?&item=${key}&other=false`}>
          <Card.Img variant='top' src={img}/>
          <Card.Body>
            <Card.Title>{title}</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">{calories}</Card.Subtitle>
          </Card.Body>
        </a>
      </Card>
    )
  })
  const GiftCards = GiftCardItems.map( ({img, title, key}) => {
    return (
      <Card style={{ width: '14rem' }} className='border-0 item'>
        <a href={`#/menu/product?&item=${key}&other=true`}>
          <Card.Img variant='top' src={img} />
          <Card.Body>
            <Card.Title>{title}</Card.Title>
          </Card.Body>
        </a>
      </Card>
    )
  })
  const Rewards = RewardsItems.map( ({img, title, lDesc, sDesc, link, key}) => {
    let btnText = sDesc.split(" ")[0];

    return (<>
      {(key % 2 === 0) ? <>
        <Col className={`rewards reverse card-${key}`}>
          <Card style={{ width: '50%', height: '20rem' }} className='border-0 rounded-0'>
            <Card.Img variant="top" src={img} />
            {(btnText === 'Earn') && <BsFillAwardFill />}
          </Card>
          <div className='card-div'></div>
          <Card style={{ width: '50%', height: '22rem' }} className='border-0 rounded-0'>
            <Card.Body>
              <Card.Title>{title}</Card.Title>
              {props.screenSize ? <>
                <Card.Text>{lDesc}</Card.Text>
              </> : <>
                <Card.Text>{sDesc}</Card.Text>
              </>}
              <Card.Link href={link}><Button variant='outline-light' href={props.isSignedIn ? '#/rewards' : '#/create_account'}>{btnText}</Button></Card.Link>
            </Card.Body>
          </Card>
        </Col>
        </> : <>
        <Col className={`rewards card-${key}`}>
          <Card style={{ width: '50%', height: '22rem' }} className='border-0 rounded-0'>
            <Card.Body>
              <Card.Title>{title}</Card.Title>
              {props.screenSize ? <>
                <Card.Text>{lDesc}</Card.Text>
              </> : <>
                <Card.Text>{sDesc}</Card.Text>
              </>}
              <Card.Link href={link}><Button variant='outline-light' href={props.isSignedIn ? '#/rewards' : '#/create_account'}>{btnText}</Button></Card.Link>
            </Card.Body>
          </Card>
          <div className='card-div'></div>
          <Card style={{ width: '50%', height: '20rem' }} className='border-0 rounded-0'>
            <Card.Img variant="top" src={img} />
            {(btnText === 'Unlock') && <MdLocalOffer/>}
            {(btnText === 'Streamline') && <MdShoppingCart />}
          </Card>
        </Col>
        </>}</>
    )
  })
  
  return (
    <section id='home'>
      <Carousel fade className='main-carousel'>
        {ftMenu}
      </Carousel>
      <div className="row-items bg-body-tertiary alt">
        <Container className="alt-container">
          <div className='head'>
            <h3>Menu</h3>
            <p><a href='#/menu'>See All</a></p>
          </div>
          <hr />
          <Col className='mini-carousel menu'>
            <div className='mini-carousel-control-prev' onClick={()=>{carouselScroll(false, 'menu')}}>
              <SlArrowLeft className='mini-carousel-control-prev-icon'/>
            </div>
            <Row className='mini-carousel-items'>
              {Menu}
            </Row>
            <div className='mini-carousel-control-next' onClick={()=>{carouselScroll(true, 'menu')}}>
              <SlArrowRight className='mini-carousel-control-next-icon'/>
            </div>
          </Col>
        </Container>
      </div>
      <Container className="alt-container">
      <div className='head'>
          <h3>Rewards</h3>
          <p><a href='#/rewards'>See All</a></p>
        </div>
      <hr />
      {Rewards}
      </Container>
      <div className="row-items bg-body-tertiary alt">
        <Container className="alt-container">
          <div className='head'>
          <h3>Gift Cards</h3>
          <p><a href='#/gift_cards'>See All</a></p>
          </div>
          <hr />
          <Col className='mini-carousel gift-cards'>
            <div className='mini-carousel-control-prev' onClick={()=>{carouselScroll(false, 'gift-cards')}}>
              <SlArrowLeft className='mini-carousel-control-prev-icon'/>
            </div>
            <Row className='mini-carousel-items'>
              {GiftCards}
            </Row>
            <div className='mini-carousel-control-next' onClick={()=>{carouselScroll(true, 'gift-cards')}}>
              <SlArrowRight className='mini-carousel-control-next-icon'/>
            </div>
          </Col>
        </Container>
      </div>
    </section>
  );
}